export default {"src":"/_next/static/media/education-certificate.4c9b34aa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};